<div class="wrapper container">
  <button mat-raised-button class="usuario-btn" [matMenuTriggerFor]="menuOpcoesUsuario" disableRipple="true">
    <div class="inline-element usuario-btn-content">
      <mat-icon fontSet="material-icons-outlined" class="accent-color">person</mat-icon>
      <div>{{username}}</div>
    </div>
  </button>
</div>

<mat-menu #menuOpcoesUsuario="matMenu">
  <button mat-menu-item (click)="onDadosConta()">
    <mat-icon fontSet="material-icons-outlined" class="accent-color">manage_accounts</mat-icon>
    <span class="medium-emphasis">Dados da conta</span>
  </button>
  <button mat-menu-item (click)="onLogout()">
    <mat-icon fontSet="material-icons-outlined" class="accent-color">logout</mat-icon>
    <span class="medium-emphasis">Sair</span>
  </button>
</mat-menu>
